import React, { useState } from "react";

import Observer from '@researchgate/react-intersection-observer';

import { ReactComponent as Menu1 } from '@assets/images/section-1/menu-1.svg';
import { ReactComponent as Menu2 } from '@assets/images/section-1/menu-2.svg';

import { ReactComponent as Menu1Mob } from '@assets/images/section-1/menu-1-mob.svg';
import { ReactComponent as Menu2Mob } from '@assets/images/section-1/menu-2-mob.svg';

import { ReactComponent as TextBG1 } from '@assets/images/section-1/text-bg-1.svg';
import { ReactComponent as TextBG2 } from '@assets/images/section-1/text-bg-2.svg';
import { ReactComponent as TextBG3 } from '@assets/images/section-1/text-bg-3.svg';

import { ReactComponent as MenuNumber } from '@assets/images/section-1/menu-number.svg';

import { AnimatedImages } from "@ui/moleculs/atoms/AnimatedImage";

import Image1 from '@assets/images/section-1/item-1.webp';
import Image2 from '@assets/images/section-1/item-2.webp';
import Image3 from '@assets/images/section-1/item-3.webp';

import Image1Safari14 from '@assets/images/section-1/item-1.png';
import Image2Safari14 from '@assets/images/section-1/item-2.png';
import Image3Safari14 from '@assets/images/section-1/item-3.png';

import Image1Mob from '@assets/images/section-1/item-1-mob.png';
import Image2Mob from '@assets/images/section-1/item-2-mob.png';
import Image3Mob from '@assets/images/section-1/item-3-mob.png';

import styles from './index.module.css'

type PageProps = {
  scrollDir?: string;
  isDesktopOrLaptop?: any;
  browser: any;
};

export const Page1: React.FC<PageProps> = ({ ...props }) => {
  const [isVisible, setVisible] = useState([false]);
  const { scrollDir, isDesktopOrLaptop, browser } = props;

  const handleChange = (event: any | never, index: number) => {
    const currActive = isVisible[index];
    const updateArr = [ ...isVisible ];
    updateArr[index] = event.isIntersecting || (currActive && scrollDir === 'down')
    setVisible(updateArr);
  };

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <Observer
      onChange={event => handleChange(event, 0)}
      root={null}
      rootMargin="0% 0% -20%"
    >
      <article
        id="what"
        className={`
          ${isVisible[0] ? styles.active : ``}
          ${styles.section}
          relative
          max-w-1100
          lg:w-full
          mx-auto
          mb-26
          lg:mb-40
          text-white
          z-1
        `}
      >
        <header
          className={`
            flex
            lg:inline-flex
            justify-between
            lg:justify-start
            relative
            -mt-8
            lg:mt-0
            pt-8
            lg:pt-0
            pb-6
            lg:pb-13.5
            pl-8
            mr-4
            lg:pl-0
            lg:mr-0

            overflow-hidden
            lg:overflow-visible
          `}
        >
          <h1
            className={`
              inline-flex
              flex-col
              items-stretch
              lg:items-start
              relative
              font-bold
              min-w-full
              lg:min-w-0

              text-4.78xl
              lg:text-6.5xl
            `}
          >
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              <span className={`relative`}>Что такое</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu1
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-10
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
                :
                <Menu1Mob
                  className={`
                    ${styles.menubg1}
                    absolute
                    transform
                    duration-500
                    delay-500
                    transition-all
                    -ml-3
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative -ml-6 lg:-ml-10`}>«Северный</span>
            </span>
            <span
              className={`
                relative
                transform
                duration-500
                delay-700
                transition-all
              `}
            >
              {isDesktopOrLaptop ?
                <Menu2
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    transition-all
                    mt-7
                    -ml-5
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              :
                <Menu2Mob
                  className={`
                    ${styles.menubg2}
                    absolute
                    transform
                    duration-500
                    transition-all
                    mt-2
                    -ml-3
                    max-w-full
                    lg:max-w-none
                    h-auto
                  `}
                />
              }
              <span className={`relative`}>поток-2»</span>
            </span>
          </h1>
          <h2 className={`
            absolute
            top-0
            lg:-top-8
            right-0
            lg:-right-8
            z-2
          `}>
            <MenuNumber
              width={isDesktopOrLaptop ? 92 : 72}
              height={isDesktopOrLaptop ? 229 : 179}
              className={`
                ${styles.number1}
                relative
                fill-current
              `}
            />
            <MenuNumber
              width={isDesktopOrLaptop ? 92 : 72}
              height={isDesktopOrLaptop ? 229 : 179}
              className={`
                ${styles.number2}
                absolute
                top-0
                right-0
                fill-current
              `}
            />
          </h2>
        </header>

        <Observer
          onChange={event => handleChange(event, 1)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-10 lg:mb-11vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[1]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  <span className={`text-blue-default font-bold`}>«Северный поток-2»</span> (англ. — Nord Stream 2) — магистральный газопровод из России в Германию через Балтийское море. Это — вторая нитка действующего с 2012 года газопровода «Северный поток-1». 
                </span>
              </div>
              <div className={`flex-1`} />
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 2)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              w-full
              max-w-890
              lg:mx-auto
              mb-10
              lg:mb-15vw
              overflow-hidden
              lg:overflow-visible
            `}
          >
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[2]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-300
                  relative
                  flex-1
                  flex
                  justify-center
                  lg:justify-start

                  overflow-hidden
                  lg:overflow-visible

                  z-1
                `}
              >
                {isDesktopOrLaptop ?
                  <AnimatedImages
                    id={`page-1-image-1`}
                    href={(browserName === 'safari' && browserVersion < 15) ? Image1Safari14 : Image1}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                  />
                  :
                  <img
                    className={`w-full h-auto`}
                    src={Image1Mob}
                    width={404}
                    height={273}
                    alt=""
                  />
                }
              </div>
              <div
                className={`
                  ${isVisible[2]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  flex
                  items-center
                  justify-center
                  lg:justify-start
                  flex-1
                  text-xs
                  lg:text-sm
                  leading-4.5
                  italic
                  indent-sm
                  text-white
                  z-0
                  -mt-6
                  lg:mt-0
                `}
              >
                <TextBG1
                  className={`
                    relative
                    min-w-110
                    h-auto
                  `}
                />
                <span
                  className={`
                    absolute
                    top-0
                    h-full
                    w-full

                    flex
                    items-center
                    lg:max-w-420
                    lg:pl-11.5
                    px-8
                    lg:px-0
                  `}
                >
                  27 октября 2020 года, Мекленбург-Передняя Померания, Висмар: российское трубоукладочное судно «Фортуна», на борту — спецтехника, которая используется для строительства газопровода «Северный поток-2» в Балтийском море. (Фото: Jens Büttner/dpa-Zentralbild/ZB (Фото: Jens Büttner/picture alliance via Getty Images).
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 3)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-10 lg:mb-20vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div className={`flex-1`} />
              <div
                className={`
                  ${isVisible[3]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:ml-11.5
                  `}
                >
                  Газопровод проходит через исключительные экономические зоны и территориальные воды пяти стран: <span className={`text-blue-default font-bold`}>Германии, Дании, России, Финляндии и Швеции.</span>
                </span>
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 4)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              w-full
              max-w-890
              lg:mx-auto
              mb-10
              lg:mb-15vw
              overflow-hidden
              lg:overflow-visible
            `}
          >
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[4]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex
                  items-center
                  justify-center
                  lg:justify-end
                  flex-1
                  text-xs
                  lg:text-sm
                  leading-4.5
                  italic
                  indent-sm
                  text-white
                  order-2
                  lg:order-1
                  z-0
                  -mt-6
                  lg:mt-0
                `}
              >
                <TextBG2
                  className={`
                    relative
                    min-w-110
                    h-auto
                  `}
                />
                <span
                  className={`
                    absolute
                    top-0
                    h-full
                    w-full

                    flex
                    items-center
                    lg:max-w-420
                    lg:pr-11.5
                    px-8
                    lg:px-0
                  `}
                >
                  29 апреля 2021 года, Мекленбург-Передняя Померания, Любмин: премьер-министр федеральной земли Мекленбург-Передняя Померания Мануэла Швезиг (СДПГ) и посол России в ФРГ Сергей Нечаев (2-й слева) в ходе посещения приемной станции для газа, который пойдет по газопроводу ​​«Северный поток-2» (Фото: Jens Büttner/dpa-Zentralbild/dpa (Фото: Jens Büttner/picture alliance via Getty Images).
                </span>
              </div>
              <div
                className={`
                  ${isVisible[4]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500
                
                  flex-1
                  order-1
                  lg:order-2
                  flex
                  justify-center
                  lg:justify-end

                  overflow-hidden
                  lg:overflow-visible

                  z-1
                `}
              >
                {isDesktopOrLaptop ?
                  <AnimatedImages
                    id={`page-1-image-2`}
                    href={(browserName === 'safari' && browserVersion < 15) ? Image2Safari14 : Image2}
                    orientation={`180`}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                  />
                  :
                  <img
                    className={`w-full h-auto`}
                    src={Image2Mob}
                    width={404}
                    height={273}
                    alt=""
                  />
                }
              </div>
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 5)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div className={`max-w-890 mx-8 lg:mx-auto mb-10 lg:mb-20vw`}>
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[5]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex-1
                  text-base
                  lg:text-lg
                  font-medium
                  leading-6
                  text-white
                `}
              >
                <span
                  className={`
                    inline-block
                    relative
                    indent-sm
                    lg:mr-11.5
                  `}
                >
                  «Северный поток-2» рассчитан на поставку 55 млн кубометров газа — <span className={`text-blue-default font-bold`}>это больше четверти всего экспорта российского газа в Европу.</span> Длина СП-2 — 1234 км (2468 км по двум ниткам).
                </span>
              </div>
              <div className={`flex-1`} />
            </div>
          </div>
        </Observer>

        <Observer
          onChange={event => handleChange(event, 6)}
          root={null}
          rootMargin="0% 0% -20%"
        >
          <div
            className={`
              w-full
              max-w-890
              lg:mx-auto
              mb-15vw
              overflow-hidden
              lg:overflow-visible
            `}
          >
            <div className={`flex flex-col lg:flex-row w-full`}>
              <div
                className={`
                  ${isVisible[6]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full
                  animation-delay-500

                  flex-1
                  flex
                  justify-center
                  lg:justify-start

                  overflow-hidden
                  lg:overflow-visible

                  z-1
                `}
              >
                {isDesktopOrLaptop ?
                  <AnimatedImages
                    id={`page-1-image-3`}
                    href={(browserName === 'safari' && browserVersion < 15) ? Image3Safari14 : Image3}
                    isDesktopOrLaptop={isDesktopOrLaptop}
                  />
                  :
                  <img
                    className={`w-full h-auto`}
                    src={Image3Mob}
                    width={404}
                    height={273}
                    alt=""
                  />
                }
              </div>
              <div
                className={`
                  ${isVisible[6]? `animate-opacity` : ``}

                  transform
                  opacity-0
                  translate-y-full

                  relative
                  flex
                  items-center
                  justify-center
                  lg:justify-start
                  flex-1
                  text-xs
                  lg:text-sm
                  leading-4.5
                  italic
                  indent-sm
                  text-white
                  z-0
                  -mt-6
                  lg:mt-0
                `}
              >
                <TextBG3
                  className={`
                    relative
                    min-w-110
                    h-auto
                  `}
                />
                <span
                  className={`
                    absolute
                    top-0
                    h-full
                    w-full

                    flex
                    items-center
                    lg:max-w-420
                    lg:pl-11.5
                    px-8
                    lg:px-0
                  `}
                >
                  Фильтры-сепараторы на компрессорной станции ПАО «Газпром» «Славянская», отправной точке газопровода «Северный поток-2» в Усть-Луге, Россия, 28 января 2021 года (Фото: Andrey Rudakov/Bloomberg via Getty Images)
                </span>
              </div>
            </div>
          </div>
        </Observer>

      </article>
    </Observer>
  );
}